
/* -----------------------------------------------------------------------------------------------------
  - Created: [20-02-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains InvoiceReportTable using MUI components
  ------------------------------------------------------------------------------------------------------- */

import React, { useEffect, useState } from 'react';
import CustomBottomPagination from '../../../../Components/custom_components/CustomBottomPagination/CustomBottomPagination';
import InvoiceReportFilter from '../InvoiceReportFilter/InvoiceReportFilter';
import CustomTable from '../../../../Components/custom_components/CustomTable/CustomTable';
import Loader from '../../../../Components/Loader/Loader';
import { handlePaginationEntries } from '../../../../utils/pagination';
import { get_invoice_reports_with_pagination } from '../../../../config/ReportApis/invoiceReportApis';
import useDataExport from '../../../../utils/useDataExport';

function InvoiceReportTable() {


    // Initialize with current values
    // const currentYear = new Date().getFullYear();
    // const currentMonth = String(new Date().getMonth() + 1).padStart(2, '0');

    const [invoiceReport, setInvoiceReport] = useState([]);

    // Calculate the total pages based on the number of items and items per page
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItemPerPage, setTotalItemPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(0);
    const [pagination, setPagination] = useState({ start: 0, end: 0, totalEntries: 0 });

    const [filterValues, setFilterValues] = useState({
        invoice_no: '',
        client: '',
        worksite: '',
        projectId: '',
        month: '', year: ''
    }); // Define filter values state
    const [isLoading, setIsLoading] = useState(false); // Loader state


    // Columns for the table
    const columns = [
        { title: "#", key: "key" },
        { title: "Invoice No", key: "InvoiceNo" },
        { title: "Project", key: "project" },
        { title: "WorkSite", key: "WorkSite" },
        { title: "Schedule Code", key: "ScheduleCode" },
        { title: "Client", key: "Client" },
        { title: "Amount", key: "Amount" },
        { title: "Status ", key: "Status" },
        { title: "Created ", key: "Created" },

    ]

    // Map the schedule data into table rows
    const rows = () => invoiceReport?.map((item, index) => ({
        key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
        InvoiceNo: item.InvoiceNo,
        WorkSite: item.WorkSite,
        ScheduleCode: item?.ScheduleCode,
        Client: item.Client,
        Amount: item.Amount,
        Status: item?.Status,
        project: item?.PrjectName,
        Created: item?.Createdat,

    }));

    // Export Headers (same as response field)
    const headers = columns.map(col => col.title);
    const mapDataFn = (item, index) => [
        index + 1,
        item?.InvoiceNo || "—",
        item?.PrjectName || "—",
        item?.WorkSite || "—",
        item?.ScheduleCode || "—",
        item?.Client || "—",
        item?.Amount || "—",
        item?.Status || "—",
        item?.Createdat || "—",

    ];
    const {
        handleExportExcel,
        handleExportPDF,
        isExportingExcel,
        isExportingPDF,
    } = useDataExport(
        get_invoice_reports_with_pagination,
        mapDataFn,
        headers,
        "Invoice Report"
    );

    // Fetch schedule data on page change or refresh
    useEffect(() => {
        getInvoiceReportList();
    }, [pageNumber, totalItemPerPage, filterValues]);


    // Fetch schedule data from API
    const getInvoiceReportList = async () => {
        const formData = new FormData();
        formData.append('page', pageNumber);
        formData.append('pageItemcount', totalItemPerPage);

        // Append filter values to formData
        Object.keys(filterValues).forEach(key => formData.append(key, filterValues[key]));

        try {
            setIsLoading(true)
            const response = await get_invoice_reports_with_pagination(formData);
            if (response?.status === "success") {
                const data = response?.data;
                setInvoiceReport(data?.data);
                setTotalPages(data.last_page);
                setPagination(handlePaginationEntries(data.from, data.to, data.total));
            } else {
                setInvoiceReport([]);
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    };

    // Handle search filter change
    const handleSearchFilter = (filterValues) => {
        setFilterValues(filterValues);
    };

    // Handle pagination changes
    const handlePageChange = (pageNumber) => setPageNumber(pageNumber);
    const handleItemPageCountChange = (pageItemCount) => setTotalItemPerPage(pageItemCount);


    return (
        <div className='report-table-container'>
            <InvoiceReportFilter
                tableTitle="Invoice Report"
                searchFilter={handleSearchFilter}

                on_change_value={handlePageChange}
                on_page_count_update={handleItemPageCountChange}

                onExportPDF={() => handleExportPDF(filterValues, { page: 1, pageItemCount: pagination?.totalEntries })}
                onExportExcel={() => handleExportExcel(filterValues, { page: 1, pageItemCount: pagination?.totalEntries })}
                isExportingPDF={isExportingPDF}
                isExportingExcel={isExportingExcel}

            />
            <div className="table-container">
                <CustomTable
                    columns={columns}
                    rows={isLoading ? [] : rows()}
                    isLoading={isLoading}
                    isCheckbox={false}

                />
            </div>
            <div className='pagination-container'>
                {isLoading ? <Loader /> : <CustomBottomPagination
                    items_per_page={totalItemPerPage}
                    current_page={pageNumber}
                    total_page_count={totalPages}
                    on_change_value={handlePageChange}
                    on_page_count_update={handleItemPageCountChange}
                    pagination={pagination}
                />}
            </div>
        </div>
    );
}

export default InvoiceReportTable;
